module.exports = __webpack_public_path__ + "assets/img/c7ae-zm.svg";